"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maybeFetchMonthFormatOptions = exports.maybeFetchDateTimeFormatOptions = void 0;

var _of = require("rxjs/observable/of");

var _filter = require("rxjs/operators/filter");

var _mergeMap = require("rxjs/operators/mergeMap");

var _map = require("rxjs/operators/map");

var _actions = require("settings-ui-sdk/BlogLanguages/actions");

var _UpdateBlogSettings = _interopRequireDefault(require("../stagedObjects/UpdateBlogSettings"));

var _constants = require("settings-ui-sdk/Blogs/constants");

var fetchDateTimeFormatOptionsOnTheseActions = [_UpdateBlogSettings.default.getStageForEditActionType(), _UpdateBlogSettings.default.getChangePropertyActionType(_constants.LANGUAGE), _UpdateBlogSettings.default.getChangePropertyActionType(_constants.PUBLISH_DATE_FORMAT)];

var maybeFetchDateTimeFormatOptions = function maybeFetchDateTimeFormatOptions($action, _ref) {
  var getState = _ref.getState;
  return $action.pipe((0, _filter.filter)(function (action) {
    return fetchDateTimeFormatOptionsOnTheseActions.indexOf(action.type) !== -1;
  }), (0, _map.map)(function () {
    return {
      language: _UpdateBlogSettings.default.getStagedProperty(_constants.LANGUAGE)(getState()),
      selectedFormat: _UpdateBlogSettings.default.getStagedProperty(_constants.PUBLISH_DATE_FORMAT)(getState())
    };
  }), (0, _mergeMap.mergeMap)(function (_ref2) {
    var language = _ref2.language,
        selectedFormat = _ref2.selectedFormat;
    return (0, _of.of)((0, _actions.loadDateTimeFormatOptions)(language, selectedFormat));
  }));
};

exports.maybeFetchDateTimeFormatOptions = maybeFetchDateTimeFormatOptions;
var fetchMonthFormatOptionsOnTheseActions = [_UpdateBlogSettings.default.getStageForEditActionType(), _UpdateBlogSettings.default.getChangePropertyActionType(_constants.LANGUAGE), _UpdateBlogSettings.default.getChangePropertyActionType(_constants.MONTH_FILTER_FORMAT)];

var maybeFetchMonthFormatOptions = function maybeFetchMonthFormatOptions($action, _ref3) {
  var getState = _ref3.getState;
  return $action.pipe((0, _filter.filter)(function (action) {
    return fetchMonthFormatOptionsOnTheseActions.indexOf(action.type) !== -1;
  }), (0, _map.map)(function () {
    return {
      language: _UpdateBlogSettings.default.getStagedProperty(_constants.LANGUAGE)(getState()),
      selectedFormat: _UpdateBlogSettings.default.getStagedProperty(_constants.MONTH_FILTER_FORMAT)(getState())
    };
  }), (0, _mergeMap.mergeMap)(function (_ref4) {
    var language = _ref4.language,
        selectedFormat = _ref4.selectedFormat;
    return (0, _of.of)((0, _actions.loadMonthFormatOptions)(language, selectedFormat));
  }));
};

exports.maybeFetchMonthFormatOptions = maybeFetchMonthFormatOptions;